/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgradeRuleByDeviceTypeResponse
 */
export interface UpgradeRuleByDeviceTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleByDeviceTypeResponse
     */
    name?: string;
}

export function UpgradeRuleByDeviceTypeResponseFromJSON(json: any): UpgradeRuleByDeviceTypeResponse {
    return UpgradeRuleByDeviceTypeResponseFromJSONTyped(json, false);
}

export function UpgradeRuleByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function UpgradeRuleByDeviceTypeResponseToJSON(value?: UpgradeRuleByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

